export default {
  metrics: {
    go_lives: 'Total Go Lives',
    avg_quality_score: 'Average Quality Score',
    managers: {
      title: 'Onboarding Managers',
      fields: {
        name: 'Manager Name',
        go_lives: 'Go Lives',
        avg_quality_score: 'Avg Quality Score',
      },
    },
  },
  details: {
    name: 'Restaurant',
    owner: 'Owner name',
    owner_phone: 'Owner phone',
    owner_email: 'Owner email',
    live_from: 'Go-Live date',
    onboarding_manager: 'Onboarding Manager',
    sales_manager: 'Sales Manager',
    onboarding_quality_score: 'Quality Score',
    export_csv: 'Export CSV',
  },
};
